import { sendLogError } from "./api";
import { API_URL } from "./axios";
function checkResponse(res) {
  let result = true;
  let payload = {
    api: res.config.url || window.location.pathname,
    message: "API response is empty",
    status: res.status || "Not Found",
  };

  if (res.status === 200) {
    const data = res.data;
    if (
      data === undefined ||
      data === null ||
      (typeof data === "string" && data.length == 0)
    ) {
      result = false;
    }

    if (typeof data === "object" && "errorCode" in data) {
      payload.message = data;
      result = false;
    }

    if (!result) {
      if (res.config.url !== `${API_URL.mp}/logger/log`) {
        sendLogError(payload);
      }
    }

    return result;
  }
}

const logError = error => {
  window.log({
    path: error?.config?.url,
    status: String(error?.response?.status || ""),
    res: error?.response?.data,
    req: {
      params: error?.config?.params,
      body: error?.config?.data || error?.request?.body,
    },
    requestDate: error?.config?.metadata?.startTime,
    responseDate: error?.config?.metadata?.endTime,
    responseTime: `${error.duration}ms`,
  });
};

const responseError = response => {
  window.log({
    path: response.config.url,
    status: String(response.status || ""),
    res: response.data,
    req: response?.config?.params || response?.request?.body,
    requestDate: response.config.metadata.startTime,
    responseDate: response.config.metadata.endTime,
    responseTime: `${response.duration}ms`,
  });
  sendLogError({
    path: response.config.url,
    status: String(response.status || ""),
    res: response.data,
    req: response?.config?.params || response?.request?.body,
    requestDate: response.config.metadata.startTime,
    responseDate: response.config.metadata.endTime,
    responseTime: `${response.duration}ms`,
  });
};
export { checkResponse, logError, responseError };
